/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { Injectable, inject } from '@angular/core';
import { Actions, EffectSources } from '@ngrx/effects';
import { ResourceRepository } from '../resource/resource.repository';
import { ListResourceLoadActions, SingleResourceLoadActions } from './actions';
import { ListResourceEffects } from './list-resource.effects';
import { ResourceEffects } from './resource.effects';

@Injectable({ providedIn: 'root' })
export class EffectService {
  private readonly actions$ = inject(Actions);
  private readonly effectSources = inject(EffectSources);
  private readonly repository = inject(ResourceRepository);

  public addSingleResourceEffects(resourceActions: SingleResourceLoadActions): void {
    this.effectSources.addEffects({
      ...new ResourceEffects(this.actions$, this.repository, resourceActions),
    });
  }

  public addListResourceEffects(resourceActions: ListResourceLoadActions): void {
    this.effectSources.addEffects({
      ...new ListResourceEffects(this.actions$, this.repository, resourceActions),
    });
  }
}
